/**
 * all actions for fund state
 *
 * Created by Min on 16/08/18
 */

import C from '../constants'

// action to show/hide loader
export const showFundLoader = booleanVal => {
    return {
        type: C.SET_FUND_LOADER,
        payload: booleanVal
    }
}

// action to set fund info data
// payload is the complete fund info data
export const setFundInfoData = objectVal => {
    return {
        type: C.SET_FUND_INFO_DATA,
        payload: objectVal
    }
}

// action to set fund memebers and trustees data
// payload is the complete fund info data
export const setMembersTrusteesInfoData = objectVal => {
    return {
        type: C.SET_MEMBERS_TRUSTEES_DATA,
        payload: objectVal
    }
}


/* -----------------------------------------------------------------------------
    ACTIONS CREATORS
----------------------------------------------------------------------------- */
// call the action to fetch the data
// NOTE: this will be picked up by the profile saga (sagas/profile.js)
export const getFundData = () => {
    return {
        type: C.FETCH_FUND_DATA,
    }
}



// WEBPACK FOOTER //
// ./src/actions/fundActions.js